"use client";

import { Card, Link } from "@heroui/react";
import { ArrowRight, type LucideIcon } from "lucide-react";

interface WorkspaceCard {
  title: string;
  description: string;
  href: string;
  action: string;
  icon: LucideIcon;
}

export function WorkspaceCards({ items }: { items: WorkspaceCard[] }) {
  return <div className="grid min-w-0 grid-cols-1 gap-6 md:grid-cols-2">
    {items.map(({ title, description, href, action, icon: Icon }) => <Link key={href} href={href} aria-label={action} className="block min-w-0 text-foreground no-underline">
      <Card className="h-full min-w-0 gap-6 p-6 sm:p-8">
      <Icon aria-hidden="true" className="size-8 text-accent" />
      <Card.Header>
        <Card.Title className="text-xl">{title}</Card.Title>
        <Card.Description>{description}</Card.Description>
      </Card.Header>
      <Card.Footer className="mt-auto">
        <span className="flex h-10 items-center gap-2 text-sm font-medium text-accent md:h-9"><ArrowRight aria-hidden="true" className="size-4" />{action}</span>
      </Card.Footer>
    </Card></Link>)}
  </div>;
}
